import "./TopNavbar.scss";

import React, { memo, useState } from "react";
import { NavLink, useParams } from "react-router-dom";

import { Logo } from "@/assets/svg/svgIcons";

import ElementNavBar from "../ElementNavbar/ElementNavbar";
import type { NavItemType } from "../Navbar";
import SubMenuNavbar from "../SubMenuNavbar/SubMenuNavbar";

interface TopNavbarProps {
  navItems: NavItemType[];
  beforeChildren?: React.ReactNode;
  children?: React.ReactNode;
  showLogo?: boolean;
  showLinkLogo?: boolean;
}

const TopNavbar = ({
  navItems,
  beforeChildren,
  children,
  showLogo = true,
  showLinkLogo = true,
}: TopNavbarProps) => {
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null);
  const { lang } = useParams<{ lang: string }>();
  const homeLink = lang ? `/${lang}/` : "/";

  const handleSubmenuToggle = (text: string) => {
    setOpenSubmenu(openSubmenu === text ? null : text);
  };

  return (
    <nav className="topNavbar" role="navigation" aria-label="Site Navigation">
      <div className="navbar-content">
        {showLogo && (
          <div className="navLogoDiv">
            <NavLink to={homeLink} aria-label="CovalTech">
              <Logo className="navLogo" />
              <span>
                Coval<span className="accentText">Tech</span>
              </span>
            </NavLink>
          </div>
        )}

        {beforeChildren && (
          <div className="before-children">{beforeChildren}</div>
        )}

        <ul className="navbar-nav">
          {navItems.map((item) =>
            item.type === "submenu" ? (
              <SubMenuNavbar
                key={item.text}
                navItem={item}
                openParent={true}
                showLinkLogo={showLinkLogo}
                isTopNavbar={true}
                isOpen={openSubmenu === item.text}
                onToggle={() => handleSubmenuToggle(item.text)}
              />
            ) : (
              <ElementNavBar
                key={item.href + item.text}
                navItem={item}
                open={true}
                showLinkLogo={showLinkLogo}
              />
            ),
          )}
        </ul>

        {children && <div className="after-children">{children}</div>}
      </div>
    </nav>
  );
};

export default memo(TopNavbar);
